import React from 'react';
import { CollapseCard } from '@totalsoft/rocket-ui';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { emptyArray } from 'constants/emptyConst';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import FolderExternalChecksListContainer from './ListContainer';

const FolderExternalChecksComponent = ({ checks, folderId, folderSiteId }) => {
  const [t] = useTranslation();

  return (
    <CollapseCard
      id={'folder_decision_externalChecksCard'}
      icon={DoneAllIcon}
      title={t('Folder.VerificationsSummary.Title')}
      toggleOnHeaderClick
    >
      <FolderExternalChecksListContainer checks={checks ?? emptyArray} folderId={folderId} folderSiteId={folderSiteId} />
    </CollapseCard>
  );
};

FolderExternalChecksComponent.propTypes = {
  checks: PropTypes.array,
  folderId: PropTypes.number.isRequired,
  folderSiteId: PropTypes.number.isRequired
};

export default FolderExternalChecksComponent;
